function RemarkDiv(props) {
    return (
      <>
        <div className={props.class} style={props.style}>
            {props.remark}
        </div>
      </>
    );
  }
  
export default RemarkDiv;